module.exports = __webpack_public_path__ + "media/hallBgm.58fc2fe1.mp3";